import DevicesDelete from './DevicesDelete'

export default DevicesDelete
